export const SELECT_ELEMENT = 'SELECT_ELEMENT'
export const DISMISS_ELEMENT = 'DISMISS_ELEMENT'
export const TOGGLE_WAGE_MODAL = 'OCCUPATION_TOGGLE_WAGE_MODAL'
export const TOGGLE_JOB_MODAL = 'OCCUPATION_TOGGLE_JOB_MODAL'

export const toggleWageModal = v => dispatch => {
  return dispatch({ type: TOGGLE_WAGE_MODAL, isVisible: v })
}

export const toggleJobModal = v => dispatch => {
  return dispatch({ type: TOGGLE_JOB_MODAL, isVisible: v })
}

export const selectElement = t => dispatch => {
  return dispatch({ type: SELECT_ELEMENT, element: t })
}

export const dismissElement = () => dispatch => {
  return dispatch({ type: DISMISS_ELEMENT })
}
